export default function FeatureCard({ title, desc }) {
    return (
      <div className="bg-secondary border border-gray-200 rounded-2xl p-6 hover:shadow-md transition">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-700">{desc}</p>
      </div>
    );
  }
  